import { useState } from 'react';
import { SUBSCRIPTION_LEVELS } from '@sdk/account/constants';
import type { AuthUserType } from '@sdk/authentication/types/AuthUserType';

import { FeatureNames } from '@web/account/types';

import {
  premiumFeatureDescription,
  PremiumFeatureDescription,
} from '../constants/premiumFeaturesDescription';

const useFeatureList = (
  user: AuthUserType,
  hiddenKeys: FeatureNames[]
): PremiumFeatureDescription[] => {
  const [featureList] = useState<PremiumFeatureDescription[]>(() => {
    const { org, orgSettings } = user;
    const isPremiumCurrentPlan =
      org.isPremium && !org.isBusinessSubscription && !org.subscriptionCancelDate;
    const level = isPremiumCurrentPlan
      ? SUBSCRIPTION_LEVELS.OLD_PREMIUM
      : SUBSCRIPTION_LEVELS.PREMIUM;
    return premiumFeatureDescription.filter(
      ({ key }) => !hiddenKeys.includes(key) && orgSettings.premiumFeatures[key] >= level
    );
  });

  return featureList;
};

export default useFeatureList;
